import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    gifts: {
        popular: [],
        bets_and_vip: [],
        boys: [],
        girls: [],
        other: []
    },
    nextGifts: {
        popular: '',
        bets_and_vip: '',
        boys: '',
        girls: '',
        other: ''
    },
    userGifts: [],
    nextUserGifts: '',
    count: '',
    errors: {}
};

getters['fetchGifts'] = function(state) { return state.gifts }
getters['fetchGiftsNext'] = function(state) { return state.nextGifts }
getters['fetchUserGifts'] = function(state) { return state.userGifts }
getters['fetchUserGiftsNext'] = function(state) { return state.nextUserGifts }
getters['fetchGiftsCount'] = function(state) { return state.count }

const actions = {
    get(context, payload) {
        return ApiService
            .get('gifts/?q=' + payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_GIFTS', [
                    response.data.results, payload
                ]);
                context.commit('SET_NEXT', [
                    'nextGifts',
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param,
                    payload
                ]);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context, payload) {
        return ApiService
            .get(context.state.nextGifts[payload])
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_GIFTS', [
                    response.data.results, payload
                ]);
                context.commit('SET_NEXT', [
                    'nextGifts',
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param,
                    payload
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getMyGifts(context) {
        return ApiService
            .get('gifts/my/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_USER_GIFTS', response.data.results);
                context.commit('SET_NEXT', [
                    'nextUserGifts',
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param,
                ]);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    }, 
    getUserGifts(context, payload) {
        return ApiService
            .get('gifts/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_USER_GIFTS', response.data.results);
                context.commit('SET_NEXT', [
                    'nextUserGifts',
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param,
                ]);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getUserNext(context) {
        return ApiService
            .get(context.state.nextUserGifts)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_USER_GIFTS', response.data.results);
                context.commit('SET_NEXT', [
                    'nextUserGifts',
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    sendGift(context, payload) {
        return ApiService
            .post('gifts/give/', payload)
            .then(() => {
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    activate(context, payload) {
        return ApiService
            .get('gifts/activate/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_ACTIVATED', payload);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_GIFTS(state, [gifts, type]) {
        state.gifts[type] = gifts;
    },
    ADD_GIFTS(state, [gifts, type]) {
        state.gifts[type] = state.gifts[type].concat(gifts);
    },
    SET_ACTIVATED(state, gift) {
        for (let i in state.userGifts) {
            if (state.userGifts[i].id == gift) {
                state.userGifts[i].activated = true;
                break;
            }
        }
    },
    SET_USER_GIFTS(state, userGifts) {
        state.userGifts = userGifts;
    },
    ADD_USER_GIFTS(state, userGifts) {
        state.userGifts = state.userGifts.concat(userGifts);
    },
    SET_COUNT(state, count) {
        state.count = count;
    },
    SET_NEXT(state, [
        stateNext, page, num_pages, url, page_param, type=false
    ]) {
        let newUrl;
        let symbol = type ? '&' : '?';
        if (page < num_pages) {
            newUrl =
            url +
            symbol +
            page_param +
            '=' +
            (page + 1);
        } else {
            newUrl = '';
        }
        if (type) {
            state[stateNext][type] = newUrl;
        } else {
            state[stateNext] = newUrl;
        }
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
